import { render, staticRenderFns } from "./Duel_Statistics_List.vue?vue&type=template&id=c5583282&scoped=true&"
import script from "./Duel_Statistics_List.vue?vue&type=script&lang=js&"
export * from "./Duel_Statistics_List.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Statistics_List.vue?vue&type=style&index=0&id=c5583282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5583282",
  null
  
)

export default component.exports